import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportToExcel = async (data, fileName) => {
  if (!data || data.length === 0) {
    alert("No data available to export!");
    return;
  }

  // Transform the data to a flat format
  const formattedData = data.map((user) => ({
    RegID: user.registrationId.toUpperCase(),
    Name: user.userId.username,
    Email: user.userId.email,
    College: user.collegeId?.collegeName || "N/A",
    Role: user.userId.role,
    Status: user.selected ? "Selected" : "Not Selected",
    Attendance: user.attendanceStatus ? "Present" : "Absent",
  }));

  // Create a new workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Participants");

  // Define column headers
  worksheet.columns = [
    { header: "Registration ID", key: "RegID", width: 30 },
    { header: "Name", key: "Name", width: 25 },
    { header: "Email", key: "Email", width: 30 },
    { header: "College", key: "College", width: 30 },
    { header: "Role", key: "Role", width: 15 },
    { header: "Status", key: "Status", width: 15 },
    { header: "Attendance", key: "Attendance", width: 15 },
  ];

  // Add data rows
  formattedData.forEach((item) => {
    worksheet.addRow(item);
  });

  // Style the header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White text
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF64C9F4" }, // Green background
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Add borders to all data rows
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber !== 1) {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    }
  });

  // Export the workbook
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};
